import { WorklistsDashboardStoreContextProvider } from '@/Stores/WorklistsDashboard/WorklistsDashboardStoreContext';
import { type PropsWithChildren } from 'react';
import { SystemSettingsContextProvider } from '../App/SystemSettingsContext';
import { FilingCabinetProvider } from './FilingCabinetContext';
import { UserContextProvider } from './UserContext';

const AuthenticatedContextProvider = (props: PropsWithChildren): React.ReactElement => {
    const { children } = props;

    return (
        <UserContextProvider>
            <SystemSettingsContextProvider>
                <FilingCabinetProvider>
                    <WorklistsDashboardStoreContextProvider>
                        {children}
                    </WorklistsDashboardStoreContextProvider>
                </FilingCabinetProvider>
            </SystemSettingsContextProvider>
        </UserContextProvider>
    );
};

export default AuthenticatedContextProvider;
